/** @format */

import * as Actions from "../actions/ActionTypes";
const ProfileReducer = (
  state = {
    isLoading: false,
    error: undefined,
    data: {
      customer_name: undefined,
      phone_number: undefined,
      email: undefined,
    },
    profile_picture: undefined,
    message: undefined,
    status: undefined,
    profileInput: {
      customer_name: undefined,
      phone_number: undefined,
      email: undefined,
      company_name: undefined,
      customer_id: undefined,
    },
    updateProfileError: "",
    profileError: {
      customer_name: "",
      phone_number: "",
      email: "",
      company_name: "",
      profile_error: "",
      api_error: "",
    },
    showEditModal: false,
  },
  action
) => {
  switch (action.type) {
    case Actions.EDIT_PROFILE_PENDING:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case Actions.EDIT_PROFILE_ERROR:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
      });
    case Actions.EDIT_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
      });
    case Actions.UPDATE_PROFILE_PENDING:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case Actions.UPDATE_PROFILE_ERROR:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error,
      });
    case Actions.UPDATE_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
      });
    case Actions.UPDATE_PROFILE_PICTURE:
      return Object.assign({}, state, {
        isImageLoading: true,
        profile_picture: action.profileImage,
      });
    case Actions.UPDATE_PROFILE_PICTURE_SUCCESS:
      return Object.assign({}, state, {
        isImageLoading: false,
      });
    case Actions.UPDATE_PROFILE_PICTURE_ERROR:
      return Object.assign({}, state, {
        isImageLoading: false,
        profile_picture: undefined,
      });
    case Actions.ON_CHNAGE_PROFILE_INPUT:
      return Object.assign({}, state, {
        profileInput: action.profileInput,
      });
    case Actions.UPDATE_CUSTOMER_SUCCESS:
      return Object.assign({}, state, {
        profileInput: action.data,
      });
    case Actions.UPDATE_CUSTOMER_ERROR:
      return Object.assign({}, state, {
        profileInput: state.profileInput,
        updateProfileError: "Customer already exists with this email/phone no.",
      });
    case Actions.PROFILE_ERROR_MESSAGE:
      return Object.assign({}, state, {
        profileError: action.errorMessage,
      });

    case Actions.TOGGLE_OPEN_EDIT_PROFILE:
      return Object.assign({}, state, {
        showEditModal: !state.showEditModal,
      });
    case Actions.RESET_PROFILE_DATA:
      return Object.assign({}, state, {
        profile_picture: undefined,
      });
    default:
      return state;
  }
};

export default ProfileReducer;
